import Database from "../database/Database";

const Theme = {
  setTheme(theme, themeChanged) {
    themeChanged(theme);

    Database.set("theme", JSON.stringify(theme));

    if (theme) {
      document.body.classList.add("dark");
      document
        .querySelector('meta[name="theme-color"]')
        .setAttribute("content", "#383838");
    } else {
      document.body.classList.remove("dark");
      document
        .querySelector('meta[name="theme-color"]')
        .setAttribute("content", "#f48f01");
    }
  },
  chnage(theme, themeChanged) {
    themeChanged(!theme.isDarkTheme);

    Database.set("theme", JSON.stringify(!theme.isDarkTheme));

    if (theme.isDarkTheme) {
      document.body.classList.remove("dark");
      document
        .querySelector('meta[name="theme-color"]')
        .setAttribute("content", "#f48f01");
    } else {
      document.body.classList.add("dark");
      document
        .querySelector('meta[name="theme-color"]')
        .setAttribute("content", "#383838");
    }
  },
  getTheme() {
    return JSON.parse(Database.get("theme"));
  },
};

export default Theme;
